import { createApi } from '@reduxjs/toolkit/query/react';
import OrganizationalRole from 'models/GrowthPlan/OrganizationalRole';
import { axiosBaseQuery } from 'services/api';

const ORGANIZATIONAL_ROLE_TAG = 'OrganizationalRole';

// API slice for Organizational Roles
export const organizationalRolesApi = createApi({
  reducerPath: 'organizationalRolesApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api',
  }),
  tagTypes: [ORGANIZATIONAL_ROLE_TAG],
  endpoints: builder => ({
    listOrganizationalRoles: builder.query({
      query: query => ({
        url: '/organizational-roles/',
        params: query,
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(role => new OrganizationalRole(role)) : [],
      providesTags: [ORGANIZATIONAL_ROLE_TAG],
    }),
  }),
});

export const { useListOrganizationalRolesQuery } = organizationalRolesApi;
